// extracted by mini-css-extract-plugin
export default {"noAccessSection":"NoAccess_noAccessSection__J2EGa"};